import { Col } from 'reactstrap';
import classNames from 'classnames';
import { Icon } from '../Media';

interface Props {
  title?: string;
  text?: string;
  icon?: any;
  headlineSize?: string;
  fullCols?: boolean;
}

export const Benefit: React.FunctionComponent<Props> = (props) => {
  const {
    title,
    text,
    icon,
    headlineSize,
    // if property is set to full Cols, one benefit will have full width on mobile
    // otherwise it's getting displayed in half width besides each other
    fullCols,
  } = props;

  const benefitHeadlineClass = classNames(
    'benefit__headline',
    'prevent-hyphenation',
    { ['benefit__headline--lg']: headlineSize === 'lg' }
  );

  return (
    <Col xs={fullCols ? 12 : 6} md={fullCols && 6} lg={4} xl={fullCols ? 3 : 4}>
      <div className="benefit">
        {icon && icon}
        <div className="benefit__text-container">
          <p className={benefitHeadlineClass}>{title}</p>
          {text && <p>{text}</p>}
        </div>
      </div>
    </Col>
  );
};
